import { useState } from 'react'
import { BackButton } from '../buttons/back-button'
import { OpenAcademicTranscript } from '../buttons/open-academic-transcript'
import { StudentRequestActionButton } from '../buttons/student-request-action-button'
import {
  type ActionType,
  StudentReviewModal
} from '../dialogs/student-review-modal'
import { Show } from '../show'
import { RequestStatus } from '../titles/request-status'
import { RequestTitle } from '../titles/request-title'

interface HeaderActionsProps {
  linkHref?: string
  requestHeader?: React.ReactNode
  requestTitle?: string
  titlePage?: string
  statusName?: string
  statusColor?: string
  buttonDisabled?: boolean
  requestId?: string
}

export const HeaderActions = ({
  linkHref,
  requestTitle,
  titlePage,
  statusName,
  statusColor,
  buttonDisabled,
  requestId
}: HeaderActionsProps) => {
  const [actionType, setActionType] = useState<ActionType>()
  const closeModal = () => setActionType(undefined)

  return (
    <>
      <Show when={!!titlePage}>
        <h1 className="text-[var(--brand-gray-1)] font-bold pb-6">
          {titlePage}
        </h1>
      </Show>

      <div className="flex pb-6 gap-6">
        <div className="flex w-full items-center">
          <div className="flex w-full items-center text-2xl text-[var(--brand-blue-3)] font-bold">
            <BackButton />
            <RequestTitle title={requestTitle || ''} />
            <div className="px-2">
              <RequestStatus name={statusName} color={statusColor} />
            </div>
          </div>
          <div className="w-42">
            <OpenAcademicTranscript link={linkHref || ''} />
          </div>
        </div>

        <div>
          <StudentRequestActionButton
            grantActive={true}
            denyActive={true}
            grantAction={() => setActionType('grant')}
            denyAction={() => setActionType('deny')}
            buttonDisabled={buttonDisabled}
          />
        </div>

        <StudentReviewModal
          key={actionType}
          isOpen={!!actionType}
          setOpen={closeModal}
          actionType={actionType || 'grant'}
          requestId={requestId}
        />
      </div>
    </>
  )
}
